import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray as _isArray, isObject as _isObject } from 'lodash';
/**
 *
 * @param {Array<Object>} layersTreeState
 * @param {string} folderKey
 * @returns {Object}
 */

var getFolderByKey = function getFolderByKey() {
  var layersTreeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var folderKey = arguments.length > 1 ? arguments[1] : undefined;

  var _iterator = _createForOfIteratorHelper(layersTreeState),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (item && item.type === 'folder' && item.key === folderKey) {
        return item;
      }

      if (item.type === 'folder') {
        var foundFolder = getFolderByKey(item.items, folderKey);

        if (foundFolder) {
          return foundFolder;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
/**
 *
 * @param {Array<Object> | Object} layersTree
 * @param {string} layerKey
 * @returns {Object|null}
 */


var getFolderByLayerKey = function getFolderByLayerKey(layersTree, layerKey) {
  if (_isArray(layersTree)) {
    var _iterator2 = _createForOfIteratorHelper(layersTree),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        var folder = getFolderByLayerKey(item, layerKey);

        if (folder) {
          return folder;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  if (_isObject(layersTree)) {
    //check if some child layer has same key
    if (layersTree && layersTree.type === 'folder') {
      var containsLayer = layersTree.items.some(function (item) {
        return item.key === layerKey;
      });

      if (containsLayer) {
        return layersTree;
      }

      var _iterator3 = _createForOfIteratorHelper(layersTree.items),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item = _step3.value;

          if (_item.type === 'folder') {
            var foundFolder = getFolderByLayerKey(_item, layerKey);

            if (foundFolder) {
              return foundFolder;
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    } else {
      return null;
    }
  }
};

var getFlattenLayerTree = function getFlattenLayerTree() {
  var layersTree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var layerTreeKeys = Object.entries(layersTree);
  var flattenLayers = layerTreeKeys.reduce(function (acc, val) {
    var _val = _slicedToArray(val, 2),
        tree = _val[1];

    var flattenLayers = getFlattenLayers(tree);
    return [].concat(_toConsumableArray(acc), _toConsumableArray(flattenLayers));
  }, []);
  return flattenLayers;
};
/**
 * Return ordered layers from given layerTree from bottom to top.
 * @param {*} layersTree
 * @returns {Array}
 */


var getFlattenLayers = function getFlattenLayers() {
  var layersTree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var flatLayers = function flatLayers(branch) {
    return branch.reduce(function (acc, item) {
      switch (item.type) {
        case 'folder':
          return [].concat(_toConsumableArray(acc), _toConsumableArray(flatLayers(item.items)));

        case 'layerTemplate':
          return [].concat(_toConsumableArray(acc), [item]);

        default:
          return acc;
      }
    }, []);
  };

  return _toConsumableArray(flatLayers(layersTree).reverse());
};
/**
 * Get z-index for layer from layerTree
 * @param {*} layersTree
 * @param {*} layerTemplateKey
 * @returns {Number|null}
 */


var getLayerZindex = function getLayerZindex(layersTree, layerTemplateKey) {
  var flattenLayers = getFlattenLayerTree(layersTree);
  var zIndex = flattenLayers.findIndex(function (l) {
    return l.key === layerTemplateKey;
  });
  return zIndex === -1 ? null : zIndex;
};
/**
 * Iterate over all tree leaf that are not folder
 * @param {Object} tree
 * @param {function} callback
 */


var forAllTreeItems = function forAllTreeItems() {
  var layerTree = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return layerTree.reduce(function (accumulator, item) {
    if (item.type === 'folder') {
      return forAllTreeItems(item.items, callback);
    } else {
      var transformed = callback(item);

      if (transformed) {
        return [].concat(_toConsumableArray(accumulator), [transformed]);
      } else {
        return accumulator;
      }
    }
  }, []);
};

export default {
  forAllTreeItems: forAllTreeItems,
  getFlattenLayers: getFlattenLayers,
  getFlattenLayerTree: getFlattenLayerTree,
  getFolderByKey: getFolderByKey,
  getFolderByLayerKey: getFolderByLayerKey,
  getLayerZindex: getLayerZindex
};